export function decodeJwtPayload(token) {
    const base64Url = token.split('.')[1];
    // jwt payload is not simply base64 encoded, but base64url encoded
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // atob (in some engines) is not tolerant to missing padding, let's fix up the padding
    // Note that this cannot be tested in Node.JS as it doesn't seem to care.
    // Taken from: https://github.com/auth0/jwt-decode/blob/master/lib/base64_url_decode.js
    switch (base64.length % 4) {
        case 0:
            break;
        case 2:
            base64 += "==";
            break;
        case 3:
            base64 += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    // atob treats the input as if it was a latin1 string that was base64url encoded, but JSON is by definition UTF-8 encoded.
    // The following turns that into utf-8, so that we don't fail on special characters.
    // Implementation based on: https://stackoverflow.com/a/38552302/55267
    const bytes = Uint8Array.from(atob(base64).split('').map(x => x.charCodeAt(0)));
    const jsonPayload = new TextDecoder("utf-8", { fatal: true }).decode(bytes);
    return JSON.parse(jsonPayload);
}
